var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center icon-div",class:{
    'icon-div-chosen': _vm.iconCode[1] === _vm.focusedIcon,
  },on:{"click":function($event){return _vm.$emit('change', _vm.iconCode[1])},"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('font-awesome-icon',{staticClass:"icon-edit-icon-modal",attrs:{"icon":_vm.iconCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }